<template>
  <div class="basic register-entrance">

    <div class="basic-header">
      <p>- 展会选择/Exhibition selection -</p>
    </div>

    <div class="choice">
      <Row :gutter="40">
        <Col span="24">
        <div class="select-box group1">
          <div class="select-content">
            <!-- @on-change="changeExId" -->
            <RadioGroup v-model="exhibitionSelectId" style="    width: 100%;">
              <Row>

                <!-- <Col v-if="false" span="12" style="margin-bottom: 26px" class="myRadio">
                <Radio label="3eca2a09-97bf-4f12-b7e9-861d6d14ec6b"><span
                    class="fontWeight">2026(春)中国国际健康营养博览会(2026年05月13日-15日 上海)</span></Radio>
                </Col> -->

                  <Col span="12" style="margin-bottom: 26px" class="myRadio">
                <Radio label="4e0e7148-4ad6-41f4-99a7-269e356d6391"><span
                    class="fontWeight">2026(秋)中国国际健康营养博览会(2026年10月21日-23日 北京)</span></Radio>
                </Col>

              </Row>
            </RadioGroup>

          </div>
        </div>
        </Col>
      </Row>
    </div>


    <div class="basic-header" v-if='area1.length > 0'>
      <p>- 展区选择/Select Exhibition -</p>
    </div>
    <div class="choice" v-if='area1.length > 0'>
      <Row :gutter="40">
        <Col span="24">
        <div class="select-box">
          <div class="select-content">
            <!-- <CheckboxGroup v-model="areaName" vertical @on-change="changeArea"> -->

            <!-- <RadioGroup v-model="areaName" vertical @on-change="changeRadio"> -->
            <CheckboxGroup v-model="areaName" vertical @on-change="changeRadio" >
              <template>
                <Row>
                  <template v-for="(item, index) in area1">
                    <Col span="6" style="margin-bottom: 26px" :key="index" v-if="item.name.length < 36" class="myRadio">
                    <Checkbox :label="item.name"  :disabled="isCheckboxDisabled(item.name)"></Checkbox>
                    </Col>
                    <Col span="24" style="margin-bottom: 26px" :key="index" v-else class="myRadio">
                    <Checkbox :label="item.name"  :disabled="isCheckboxDisabled(item.name)"></Checkbox>
                    </Col>
                  </template>
                </Row>
              </template>
            </CheckboxGroup>
          </div>
        </div>
        </Col>
      </Row>
    </div>
    <div class="basic-header" v-if="selectArea.length">
      <p>- 展位选择/Exhibition Stand Request -</p>
    </div>
    <!-- shellInfo:{{shellInfo}} <br />
    RawInfo:{{RawInfo}} <br /> -->
    <div class="choice" v-if="selectArea.length">
      <div class="select-box">
        <div class="select-content" style="padding: 30px 40px">
          <Row>
            <Col span="12">
            <div class="top">
              <div class="top-title">
                特装展位<span class="top-txt2">（18m²起订）/Space Only（Minimum 18 sqm）
                </span>
              </div>
              <RadioGroup v-model="shellInfo" @on-change="changeType">
                <div class="top-item" v-for="(item, index) in shellArr" :key="'shell-' + index">
                  <Radio :label="item.id" style="width: 250px">{{ item.name }} {{ item.price }}元/m²</Radio>
                  <InputNumber :max="9999" :min="0" v-model="item.count" @on-change="changeInput($event, index, item)"
                    style="width: 80px" :disabled="!(shellInfo && shellInfo === item.id)">
                  </InputNumber>
                  <span style="padding-left: 10px">ｍ² </span>
                </div>
              </RadioGroup>
            </div>
            </Col>
            <Col span="12">
            <div class="top">
              <div class="top-title">
                标准展位<span class="top-txt2">（规格9m²/个）Standard Booth（9 sqm per unit）</span>
              </div>
              <RadioGroup v-model="RawInfo" @on-change="changeType2">
                <div class="top-item" v-for="(item, index) in RawArr" :key="'raw-' + index">
                  <Radio :label="item.id" style="width: 250px">{{ item.name }} {{ item.price }}元/个</Radio>
                  <InputNumber :max="9999" :min="0" v-model="item.count" @on-change="changeInput($event, index, item)"
                    style="width: 80px" :disabled="!(RawInfo && RawInfo === item.id)">
                  </InputNumber>
                  <span style="padding-left: 10px">个 </span>
                </div>
              </RadioGroup>
            </div>
            </Col>
          </Row>
          <div style="margin-bottom: 20px">
            <Checkbox v-model="isNeedUpdate">如需要进行“标改特”，请勾选</Checkbox><br /><br />
            <Checkbox v-model="isNeedAngular">如有意预订转角位，请勾选此项。标准展位转角位置（两面开展位）加收原价格的20%</Checkbox>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data() {
    return {
      isNeedUpdate: false,
      isNeedAngular: false,
      company1: "",
      productName: "",
      areaName: [],
      areaType: "",
      // 特装展位
      shellArr: [],
      // 标准展位
      RawArr: [],
      shellInfo: null,
      RawInfo: null,
      area1: [],
      selectArea: [],
      selectAreaGroupId: "",


      exhibitionSelectId: "4e0e7148-4ad6-41f4-99a7-269e356d6391",

    };
  },
  computed: {
    exAreasOption() {
      return {
        clientId: this.exhibitionSelectId == '4e0e7148-4ad6-41f4-99a7-269e356d6391' ? 36 : 35,
        // clientId: this.company1.clientId,
        languageType: "中文", // 中文|英文
      };
    },


    isZh() {
      //console.log(this.$store.state.isZh, 'this.$store.state.isZh;');
      return this.$store.state.isZh || true
    },
  },
  watch: {
    isZh() {
      this.selectArea = []
      this.areaName = []
      this.shellInfo = null
      //console.log("isZh:", newValue);

    },

    exhibitionSelectId() {
      //console.log("exhibitionSelectId:", newValue);
      this.area1 = []
      this.selectArea = [];
      this.areaName = [];
      this.shellInfo = null;
      this.getExhibitionHandle()
    },

  },

  created() {
    this.getExhibitionHandle();
  },
  methods: {
    ...mapActions({
      getExhibitionById: "registerdModule/getExhibitionById",
      getApplyCompanyGetAreasNew: "registerdModule/getApplyCompanyGetAreasNew",

      getAllArea: "getAllArea", //获取展区列表
      getCommodities: "getCommodities", //获取商品信息
    }),
    async getExhibitionHandle() {
      sessionStorage.setItem('exhibitionSelectId', this.exhibitionSelectId);
      let res = await this.getExhibitionById(this.exhibitionSelectId);
      //   let res = await this.getExhibitionById("4e0e7148-4ad6-41f4-99a7-269e356d6391");
      if (res) {
        this.company1 = res;
        //console.log("getExhibitionHandle", this.company1);
      }
      this.getApplyCompanyGetAreasHandleNew(); // 获取展区
    },
    async validHandle() {
      if (!this.exhibitionSelectId) {
        this.$Message.error("请选择展会");
        return Promise.resolve({ valid: false });
      }
      if (this.areaName.length <= 0) {
        this.$Message.error("请选择展区");
        return Promise.resolve({ valid: false });
      }
      if (!(this.RawInfo || this.shellInfo)) {
        this.$Message.error("请选择展位/Please select booth");
        return Promise.resolve({ valid: false });
      }
      let areaType = ""; // 展位类型 光地|标展
      let showArea = 0; // 展位类型为光地时 输入的展位面积
      let hallCount = 0; // 展位类型为标展时 输入的标展个数
      let selectType = null;
      if (this.shellInfo) {
        this.shellArr.forEach((c) => {
          if (c.id === this.shellInfo) {
            areaType = c.boothKind;
            showArea = c.count;
            selectType = c;
          }
        });
      }
      if (this.RawInfo) {
        this.RawArr.forEach((c) => {
          if (c.id === this.RawInfo) {
            areaType = c.boothKind;
            hallCount = c.count;
            selectType = c;
          }
        });
      }
      //console.log("areaType", areaType);
      //console.log("showArea", showArea);
      //console.log("hallCount", hallCount);
      //console.log("selectType", selectType);
      if (areaType) {
        if (areaType === "光地" && showArea < 18) {
          this.$Message.error(
            "请输入光地展位的面积(18㎡起订)/Please enter the size of the booth"
          );
          return Promise.resolve({ valid: false });
        }
        if (areaType === "标展" && !hallCount) {
          this.$Message.error(
            "请输入标准展位的个数/Please enter the number of standard booth"
          );
          return Promise.resolve({ valid: false });
        }
      } else {
        this.$Message.error("请选择您预定的展位/Please select the booth");
        return Promise.resolve({ valid: false });
      }
      
      let AllMoney=selectType.price * showArea
      if (areaType === "标展") {
        showArea = hallCount * 9;
        AllMoney=selectType.price * (showArea/selectType.boothArea)
      }
      let order = {
        exhibitionId: this.company1.id,
        showArea: showArea,
        pType: selectType.pType,
        areaType: areaType,
        areaName: this.areaName.join(","),
        hallCount: hallCount,
        AllMoney: selectType.price * hallCount,
        ApplyBoothOrder: {
          boothType: selectType.boothKind,
          boothKind: selectType.boothKind,  
          unit: selectType.unit,
          thirdPartyCommodityId: selectType.id,
          dePjNameGroupId: this.selectAreaGroupId,
          gpName: selectType.gpName,
          groupId: selectType.groupId,
          dePjNameGroupName: this.areaName.join(","),
          pjCode: selectType.pjCode,
          pjFormat: selectType.pjFormat,
          unitPrice: selectType.price,
        //   monetaryUnit: selectType.pType,
          name: selectType.name,
          monetaryUnit: 'RMB',
          area: showArea,
        },
      };
      let res = {
        isNeedUpdate: this.isNeedUpdate,
        isNeedAngular: this.isNeedAngular,
        ApplyCompanyOrderNewDto: order || {},
        exhibition: this.company1,
      };
      //console.log(res);
    
      return Promise.resolve({ valid: true, ...res });
    },
    changeType() {
      this.RawInfo = "";
      setTimeout(() => {
        let arr1 = [...this.shellArr];
        let arr2 = [...this.RawArr];
        arr1.map((e) => {
          e.count = 0;
        });
        arr2.map((e) => {
          e.count = 0;
        });
        this.shellArr = [...arr1];
        this.RawArr = [...arr2];
        //console.log("shellArr", this.shellArr);
        //console.log("RawArr", this.RawArr);
      }, 200);
    },
    changeType2() {
      this.shellInfo = "";
      setTimeout(() => {
        let arr1 = [...this.shellArr];
        let arr2 = [...this.RawArr];
        arr1.map((e) => {
          e.count = 0;
        });
        arr2.map((e) => {
          e.count = 0;
        });
        this.shellArr = [...arr1];
        this.RawArr = [...arr2];
        //console.log("shellArr", this.shellArr);
        //console.log("RawArr", this.RawArr);
      }, 200);
    },
    changeArea(e) {
      //console.log(this.areaName);
      //console.log(e);
      if (e.length > 1) {
        return;
      }
      //console.log("changeArea", e);
      this.selectAreaGroupId = e.id;
      //console.log("selectAreaGroupId", this.selectAreaGroupId);
      let arr = [];
      this.RawArr = [];
      this.shellArr = [];
      setTimeout(() => {
        this.area1.map((c) => {
          if (c.name === e[0]) {
            arr = c.pjNames || [];
          }
        });
        arr.map((c) => {
          c.count = 0;
        });
        //console.log(this.isZh, 'this.isZh');
        arr.forEach((v) => {
          //console.log(v.groupId);
          if (v.boothKind === "标展" && (this.isZh ? v.groupId == 1 : v.groupId == 2)) {
            this.RawArr.push(v);
          } else if (
            v.boothKind === "光地" && (this.isZh ? v.groupId == 1 : v.groupId == 2)
          ) {
            this.shellArr.push(v);
          }
        });
        this.selectArea = arr;
        this.shellInfo = null;
        this.RawInfo = null;
        //console.log("selectArea", this.selectArea);
        //console.log("标准展位", this.RawArr);
        //console.log("特装展位", this.shellArr);
      }, 100);
    },
    changeInput() {
      //console.log("e", e);
      //console.log("index", index);
      //console.log("item", item);
      //console.log("RawArr", this.RawArr);
      //console.log("shellArr", this.shellArr);
    },
    async getApplyCompanyGetAreasHandleNew() {
    //   let res = await this.getApplyCompanyGetAreasNew(this.exAreasOption);
     let res = await this.getAllArea(this.exhibitionSelectId);
      if (res && res.length) {
        this.area1 = res;
        //console.log("area1", this.area1);
        //console.log("getApplyCompanyGetAreasHandleNew", res);
      }
    },

    

     isCheckboxDisabled(name) {
    // 如果已选满 4 个，并且当前项未被选中，则禁用
    return this.areaName.length >= 4 && !this.areaName.includes(name);
  },

  async  changeRadio(e) {

    this.selectAreaGroupId = this.area1.find(c => c.name == e).id
    let areaId=this.area1.find(c => c.name == e).id

    let opt={
        areaId:areaId,
        exhibitionId:this.exhibitionSelectId,
        isEnable:true
    }

   let arr = await this.getCommodities(opt);

      this.RawArr = [];
      this.shellArr = [];

       setTimeout(() => {
        // this.area1.map((c) => {
        //   if (c.name === e) {
        //     arr = c.pjNames || [];
        //   }
        // });
        arr.map((c) => {
          c.count = 0;
        });
        arr.forEach((v) => {
          if (v.boothKind === "标展") {
            this.RawArr.push(v);
          } else if (v.boothKind === "特装") {
            this.shellArr.push(v);
          }
        });
        this.selectArea = arr;
        this.shellInfo = null;
        this.RawInfo = null;
        //console.log("标准展位", this.RawArr);
        //console.log("特装展位", this.shellArr);
      }, 100);
      },



  },
};
</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #00a0e9 !important;
    }

    .ivu-radio-inner:after {
      background-color: #00a0e9;
    }

    .ivu-switch-checked {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #00a0e9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      line-height: 64px;
      font-size: 20px;
    }

    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-title {
    font-size: 18px;
    line-height: 48px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;

    span {
      font-size: 14px;
    }
  }
}

.choice {
  margin-bottom: 30px;
}

.choicebox {
  min-height: 686px;
  background-color: #fff;
  border: solid 1px #e5e5e5;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &.active {
    background-color: #fdf7f9;
    border: solid 1px #00a0e9;

    .select {
      opacity: 1;
    }

    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }

    .choicebox-tool {
      background-color: #f5eff1;
    }
  }

  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #00a0e9;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #00a0e9;
    font-size: 14px;
    color: #fff;
  }

  &-content {
    padding: 30px;

    .title {
      text-align: center;
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }

    .item {
      display: flex;
      align-items: center;
      flex: 1;

      &-box {
        width: 50%;
      }

      &-box2 {
        width: 50%;

        p {
          font-size: 14px;
          color: #333;
          font-weight: normal;
        }
      }
    }

    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;

        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }

  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    border-top: solid 1px #e5e5e5;
    display: flex;
    align-items: center;
  }
}

.select-box {
  .select-content {
    padding: 40px 50px 30px;
    border: solid 1px #e5e5e5;
    border-top: none;
  }
}

.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -2px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;

      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}

.select-content-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 18px;
}

.top {
  padding: 15px 0 0;
  color: #333;

  &-txt {
    font-size: 12px;
    padding-left: 29px;
    padding-bottom: 10px;
  }

  &-txt2 {
    font-size: 14px;
  }

  &-title {
    font-size: 18px;
    margin-bottom: 28px;
  }

  &-item {
    margin-bottom: 26px;
  }
}

.bottom {
  padding: 30px;
}

.box {
  text-align: center;

  .line {
    height: 64px;
    font-size: 14px;
    color: #333;

    &:first-child {
      font-size: 16px;
      color: #fff;
      background-color: #00a0e9 !important;

      .ivu-col {
        border-right: 1px solid #fff;
      }
    }

    &:nth-child(odd) {
      background-color: #fff;
    }

    &:nth-child(even) {
      background-color: #f2fafe;
    }

    .ivu-col {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #d9f3ff;

      &:last-child {
        border-color: transparent !important;
      }
    }
  }
}

.tip {
  font-size: 12px;
  color: #333;
  line-height: 24px;
  margin-top: 30px;
}

.dot {
  position: relative;
  padding-left: 10px;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: #999;
    border-radius: 50%;
    top: 10px;
    margin-top: -2px;
  }
}

.last {
  margin-bottom: 0 !important;
}
</style>
